import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

import { FONT_PRIMARY } from "@/theme/typography";
import imageUrlSm from "@/assets/images/test-drive/bg-test-drive-sm.png";
import imageUrlLg from "@/assets/images/test-drive/bg-test-drive-lg.png";
import { ROUTES } from "@/utils/navigation";

import Section from "../Section";

const TestDrive = () => {
  return (
    <Section
      pt={{ xs: 8, md: 10, lg: 14.75 }}
      pb={{ xs: 8, md: 10, lg: 14.75 }}
      bgColor="primary.main"
      sectionSx={{
        backgroundImage: { xs: `url(${imageUrlSm})`, sm: `url(${imageUrlLg})` },
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        maxWidth={{ xs: 340, md: 543 }}
        mx="auto"
        justifyContent="center"
        alignItems="center"
      >
        <Typography
          fontFamily={FONT_PRIMARY}
          fontSize={{ xs: 24, md: 30, lg: 40 }}
          color="white"
          variant="h2"
        >
          Ready for
        </Typography>
        <Typography
          fontFamily={FONT_PRIMARY}
          fontSize={{ xs: 24, md: 30, lg: 40 }}
          color="white"
          variant="h2"
          mb={{ xs: 2 }}
        >
          a test drive?
        </Typography>
        <Typography
          color="white"
          variant="subtitle1"
          fontWeight={{ xs: 500, md: 600 }}
          mb={{ xs: 4, md: 8 }}
        >
          Try Trackmate now!
        </Typography>
        <Button variant="soft" component={Link} to={ROUTES.contactUs}>
          Book a Demo
        </Button>
      </Box>
    </Section>
  );
};

export default TestDrive;
